import React, { useEffect, useState, useCallback } from "react";
import { Payhere, AccountCategory } from "payhere-js-sdk";
import {
  Customer,
  CurrencyType,
  PayhereCheckout,
  CheckoutParams,
} from "payhere-js-sdk";
import axios from "axios";
import { getToken } from "../../auth/authenticate";

// --- Initialize PayHere based on ENV ---
const initializePayhere = () => {
  const env = (process.env.REACT_APP_PAYHERE_ENV || "").trim().toUpperCase();
  const isSandbox = env === "SANDBOX";

  if (isSandbox) {
    Payhere.init(
      process.env.REACT_APP_PAYHERE_SANDBOX_MERCHANT_ID,
      AccountCategory.SANDBOX
    );
  } else {
    Payhere.init(
      process.env.REACT_APP_PAYHERE_MERCHANT_ID,
      AccountCategory.LIVE
    );
  }
};
initializePayhere();

const url = `${process.env.REACT_APP_BACKEND_URL}payment/create`;

export const MakePayment = () => {
  const [paymentForm, setPaymentForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    addressNo: "",
    streetOne: "",
    streetTwo: "",
    city: "",
    country: "",
    currency: CurrencyType.LKR,
    amount: 0.0,
    paymentRef: "",
    paymentCategory: "APPOINTMENT",
    patientId: "1",
    appoinmentId: "1000",
  });

  // ✅ Define createPayment with useCallback to make it stable
  const createPayment = useCallback(async () => {
    const config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };

    const payResponse = await axios.post(
      url,
      {
        orderRef: paymentForm.appoinmentId,
        txnAmount: paymentForm.amount,
        category: paymentForm.paymentCategory,
        patientId: paymentForm.patientId,
        payType: "FP",
      },
      config
    );

    if (payResponse.status === 201) {
      return payResponse;
    } else {
      alert("Payment not created");
      return 0;
    }
  }, [
    paymentForm.amount,
    paymentForm.appoinmentId,
    paymentForm.patientId,
    paymentForm.paymentCategory,
  ]);

  // ✅ useEffect without missing dependencies
  useEffect(() => {
    createPayment()
      .then((payment) => {
        if (payment?.data?.data?.paymentRef) {
          setPaymentForm((prev) => ({
            ...prev,
            paymentRef: payment.data.data.paymentRef,
          }));
        }
      })
      .catch((err) => {
        console.error("Payment creation failed:", err);
        alert("Error creating payment");
      });
  }, [createPayment]);

  // --- Checkout flow ---
  function onPayhereCheckoutError(errorMsg) {
    alert(errorMsg);
  }

  async function checkout() {
    const customer = new Customer({
      first_name: paymentForm.firstName,
      last_name: paymentForm.lastName || paymentForm.firstName,
      phone: paymentForm.mobile,
      email: paymentForm.email,
      address: `${paymentForm.addressNo}, ${paymentForm.streetOne}, ${paymentForm.streetTwo}`,
      city: paymentForm.city,
      country: paymentForm.country,
    });

    // @ts-ignore
    const checkoutData = new CheckoutParams({
      returnUrl: `${process.env.REACT_APP_FRONTEND_BASE_URL}doctor/:id/add-appointments/fill-details/make-payment/thank-you`,
      cancelUrl: `${process.env.REACT_APP_FRONTEND_BASE_URL}payment/cancel`,
      notifyUrl: `${process.env.REACT_APP_BACKEND_URL}api/payment/confirmation`,
      order_id: paymentForm.paymentRef,
      itemTitle: paymentForm.paymentCategory,
      currency: paymentForm.currency,
      amount: Math.floor(paymentForm.amount),
    });

    const checkout = new PayhereCheckout(
      customer,
      checkoutData,
      onPayhereCheckoutError
    );

    setTimeout(() => {
      checkout.start();
    }, 100);
  }

  // --- UI ---
  return (
    <React.Fragment>
      <h2>Hi this is payment make page</h2>

      {Object.keys(paymentForm).map((key) =>
        typeof paymentForm[key] === "string" ||
        typeof paymentForm[key] === "number" ? (
          <div key={key}>
            <input
              type="text"
              placeholder={key}
              id={key}
              value={paymentForm[key]}
              onChange={(e) =>
                setPaymentForm((prev) => ({ ...prev, [key]: e.target.value }))
              }
            />
          </div>
        ) : null
      )}

      <button id="payhere-payment" onClick={checkout}>
        PayHere Pay
      </button>
    </React.Fragment>
  );
};
